/*
 * @Author: zhang lin
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-10 18:18:06
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Radio } from 'sup-ui';

import messages from './messages';
import styles from './index.less';

import { RadioChangeEvent } from 'sup-ui/lib/radio';
import ExtService from './components/ExtService';

const MonitorManage = () => {
  const intl = useIntl();
  const [tab, setTab] = useState<string>('extService');

  const tabData = [
    {
      type: 'extService',
      title: messages.extService,
      module: <ExtService />,
      key: '1',
      disabled: false,
    },
    { type: 'app', title: messages.app, module: null, key: '2', disabled: true },
  ];
  // 切换页签类型
  const changeType = (e: RadioChangeEvent) => {
    setTab(e.target.value);
  };

  return (
    <div className={styles.container}>
      <Radio.Group
        style={{ marginBottom: 16 }}
        value={tab}
        onChange={changeType}
        className={styles.tabGroup}
        tabBarStyle={{ textAlgin: 'center' }}
      >
        {tabData.map((i: any) => (
          <Radio.Button value={i.type} key={i.key} disabled={i.disabled}>
            {intl.formatMessage(i.title)}
          </Radio.Button>
        ))}
      </Radio.Group>
      {tab === 'extService' && <ExtService />}
    </div>
  );
};

export default MonitorManage;
